
import iconNotificationSuccess from '../Assets/Images/iconNotificationSuccess.svg';
import iconNotificationError from '../Assets/Images/iconNotificationError.svg';
import iconNotificationWarn from '../Assets/Images/iconNotificationWarn.svg';
import iconNotificationInfo from '../Assets/Images/iconNotificationInfo.svg';

const StatusNotification = (props) => {
  
    // Set status icon and class based on props.status
    const statusMapping = {
        "success": {
        icon: iconNotificationSuccess,
        className: "p-message-success"
        },
        "warn": {
        icon: iconNotificationWarn,
        className: "p-message-warn"
        },
        "error": {
        icon: iconNotificationError,
        className: "p-message-error"
        },
        "info": {
        icon: iconNotificationInfo,
        className: "p-message-info"
        }	
    }		

    return (
    <>
        <div class={`w90 p-message p-component ${!statusMapping[props.status] ? statusMapping['info'].className : statusMapping[props.status].className} p-message-enter-done`} role="alert" aria-live="assertive" aria-atomic="true" data-pc-name="messages" data-pc-section="root">
            <div class="p-message-wrapper flex-row justify-start align-items-center gap-1 flex-1" data-pc-section="wrapper">
                <img src={!statusMapping[props.status] ? statusMapping['info'].icon : statusMapping[props.status].icon} style={{width:14,height:"auto"}} />													
                <span class="p-message-summary tAlignL" data-pc-section="summary">{props.summary}</span>
                <span class="p-message-detail flex-1 tAlignL" data-pc-section="detail" style={{fontFamily:"Graphie"}}>{props.message}</span>
            </div>
        </div>
    </>
    ); 

};

export default StatusNotification;

